import { ARGS, INCLUSIONS, FALLBACK_MOANA } from './moana-data';
import { Eyebrow } from './MoanaHero';

export const MoanaArguments = ({ cms }) => (
  <>
    {/* Pourquoi */}
    <section id="pourquoi" className="py-20 bg-[#F8FAFC]" data-testid="pourquoi-section">
      <div className="max-w-[1100px] mx-auto px-4 sm:px-6 lg:px-10">
        <Eyebrow>Notre positionnement</Eyebrow>
        <h2 className="text-3xl sm:text-4xl font-bold text-[#1F2937] mb-12">
          Pourquoi choisir <em className="italic text-[#F59E0B]">Moana Paye ?</em>
        </h2>
        <div className="grid lg:grid-cols-[5fr_7fr] gap-16 lg:gap-20 items-start">
          <div>
            <p className="text-lg italic text-[#0F766E] leading-relaxed border-l-[3px] border-[#F59E0B] pl-5 mb-5">
              "{cms.pourquoi?.quote || FALLBACK_MOANA.pourquoi.quote}"
            </p>
            <p className="text-sm text-gray-500 leading-relaxed mb-3">
              {cms.pourquoi?.body || FALLBACK_MOANA.pourquoi.body}
            </p>
            <p className="text-sm text-gray-400 italic mt-5">— {cms.pourquoi?.signature || FALLBACK_MOANA.pourquoi.signature}</p>
          </div>
          <div className="space-y-0">
            {(cms.pourquoi?.args || ARGS).map((arg, i, arr) => (
              <div key={arg.num} className={`flex gap-5 items-start py-6 ${i < arr.length - 1 ? 'border-b border-gray-200' : ''}`}>
                <span className="text-base font-bold text-[#F59E0B] flex-shrink-0 w-10 mt-0.5">{arg.num} —</span>
                <div>
                  <h3 className="text-lg font-bold text-[#1F2937] mb-1.5">{arg.title}</h3>
                  <p className="text-sm text-gray-500 leading-relaxed">{arg.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>

    {/* Inclus dans la delegation */}
    <section id="inclus" className="py-20 bg-white" data-testid="inclus-section">
      <div className="max-w-[1100px] mx-auto px-4 sm:px-6 lg:px-10">
        <div className="max-w-[640px] mb-12">
          <Eyebrow>Ce que Moana Paye couvre</Eyebrow>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1F2937]">
            Inclus dans <em className="italic text-[#F59E0B]">chaque prestation</em>
          </h2>
          <p className="text-sm text-gray-500 leading-relaxed mt-3">
            Quel que soit votre mode d'utilisation, ces elements sont toujours couverts. Zero surprise.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {INCLUSIONS.map(item => (
            <div key={item.title} className="bg-white border border-gray-200 rounded-xl p-7 border-t-[3px] border-t-[#F59E0B] hover:-translate-y-1 hover:shadow-lg transition-all" data-testid={`inclus-${item.title.slice(0, 8)}`}>
              <item.icon className="w-7 h-7 text-[#0D9488] mb-3.5" />
              <h3 className="text-base font-bold text-[#1F2937] mb-2.5">{item.title}</h3>
              <p className="text-sm text-gray-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
        <div className="mt-8 py-4 px-6 bg-[#0D9488]/10 rounded-lg text-center text-sm text-[#0D9488]">
          Bulletins, déclarations, reporting — conformes au droit social polynésien. Mises à jour réglementaires automatiques.
        </div>
      </div>
    </section>
  </>
);
